import { Box, Text } from 'grommet';
import { Workshop } from 'grommet-icons';
import React from 'react'

const Working = () => {
  return (
    <Box width="full" height="full" direction="column"
    align="center" justify="center">
      <Workshop size="50px" color="white"/>
      <Text size="15px" color="white" margin="10px">
        해당 자료를 검토중입니다.
      </Text>
      <Text size="15px" color="white" margin="10px">
        2024년 상반기에 게시 예정입니다.
      </Text>
    </Box>
  )
}

export default Working;